import api from '../../../services/api';
import { getUserFactoryId, getUserId } from '../../../../index';
import buildQuery from 'odata-query';
import { orderBy } from 'lodash';

export const USERS_URL = '/user'
export const APPROVER_URL = '/approver';

/**
 * 
 * @returns 
 */
export const getAll = () => {
    return api.get(USERS_URL + '/odata/' + buildQuery({
        filter: {
            factoryId: { eq: parseInt(getUserFactoryId()) }
        },
        select: ['name', 'sap', 'id'],
        __count: true,
    }))
}

export const getApprovers = (userId) => {
    return api.get(APPROVER_URL + '/odata/' + buildQuery({
        filter: {
            userId: { eq: parseInt(userId) }
        },
        select: ['standardType', 'standardClassification', 'userId', 'id'],
        __count: true,
    }));
}

export const getApproversBySAP = (sap) => {
    return api.get(APPROVER_URL + '/odata/' + buildQuery({
        filter: {
            user: { sap: { eq: sap } }
        },
        select: ['standardType', 'standardClassification', 'userId', 'id'],
        __count: true,
    }));
}

/**
 * @typedef {object} User
 * @property {Number} id
 * @property {String} name
 * @property {String} name
 * @property {{id: Number, name: String}} systemRole
 */
/**
 * @param {Partial<import('odata-query').QueryOptions<T>>} odataQuery 
 * @returns {Promise<import('axios').AxiosResponse<OdataResponse<User>>}
 */
export const getUserOdata = (odataQuery) => {
    return api.get(USERS_URL + '/odata/' + buildQuery({ 
        ...odataQuery,
        select: [ 'id', 'factoryId', 'email', 'name', 'sap', 'status', 'systemRole', 'companyRole' ],
        expand: {
            systemRole: {
                select: [ 'name', 'id' ]
            },
            companyRole: {
                select: [ 'name' ]
            },
            UserDirectSuperior: {
                select: [ 'name' ]
            },
            deparment: {
                select: ['name']
            },
            factory: {
                select: ['name']
            }
        },
        orderBy: ['Name asc']
    }));
}
// ?$select =id,factoryId,email,name,sap,status,systemRoleId,companyRoleId,photoUrl,userDirectSuperiorId,status,password,token&
// $expand=systemRole,companyRole($select=name),UserDirectSuperior($select=name)

/**
 * @typedef {object} Roles
 * @property {Number|null} _count
 * @property {{id: Number, name: String}[]} value
 */
/**
 * @returns {Promise<import('axios').AxiosResponse<Roles>>}
 */
export function getRoles(){
    //?$select=name,%20id
    return api.get('/systemrole/odata/'+ buildQuery({
        select: [ 'name', 'id' ]
    }))
}


/**
 * 
 * @param {{userId: Number, roleId: Number}} user 
 */
export function updateUserRole ( user ) {
    return api.put('/user/ChangeSystemRole', {
        Id: user.userId,
        SystemRoleId: user.roleId,
    })
}



export function updateUserAccessTerms() {
    return api.put(`/user/FirstAccess/${getUserId()}`);
}